module.exports = {
  locale: 'pt-BR',
  countryLabel: 'BR-PT',
  
  // Article Page
  all_articles: 'TODOS OS ARTIGOS',
  relatedArticles: 'relatedArticles',
  relatedArticlesHeading: 'Mais sobre este assunto',
  recommendedProductHeading: 'Produtos relacionados',
  views: 'Visualizações: ',

  // Story Page
  knowMore: 'SAIBA MAIS',
  productPage: 'productPage',
  relatedCollectionsHeading: 'Mais Coleções',
  //Share
  copiedClipboard: 'Copiado para a área de transferência',
  toShare: 'Compartilhar',
  shareProductAriaLabel: 'Compartilhar Shampoo Reparador Molecular Bond Repair',
  tryAgain: 'Para tentar novamente.',
  //SearchPage
  noResults: 'Não foram encontrados resultados',
  searchResults: 'RESULTADOS DA BUSCA PARA ',
  rating: '*Classificação geral',
  value: 'Value',
  syndicationText: 'Postado originalmente em ',
  incentivizedText:
    'Este avaliador recebeu incentivos do fabricante do produto',

  writeReviewHeader: 'Deixe a sua avaliação',
  writeReviewError: 'Existe(m) #number erro(s) na página',
  writeReviewYes: 'Sim',
  writeReviewNo: 'Não',
  writeReviewHairType: 'Tipo de cabelo',
  writeReviewHairLength: 'Comprimento dos cabelos',
  writeReviewHairNeed: 'Necessidade do Cabelo',
  writeReviewMonth: 'Mês',
  writeReviewYear: 'ano',
  writeReviewPreview: 'Visualizar',
  ReadReviewId: 'bv-ratings-and-reviews-anchor-point',
  ratingLabel: 'Classificação geral',
  valueLabel: 'Valor',
  qualityLabel: 'Qualidade',
  recommendLabel: 'Você recomendaria este produto?',
  reviewSummaryLabel: 'Confirme sua avaliação',
  reviewSummaryHint: 'Exemplo: Este produto é exatamente o que eu precisava!',
  reviewLabel: 'Sua avaliação',
  reviewHint:
    'Exemplo: Este produto tem excelentes benefícios, eu gosto especialmente de…',
  informationHeader: 'SUAS INFORMAÇÕES',
  nickNameLabel: 'Escolha um apelido',
  nickNameHint:
    'Por razões de privacidade, não use seu nome completo ou e-mail.',

  hairTypeLabel: 'Tipo de cabelo',
  hairLengthLabel: 'Comprimento dos cabelos',
  hairNeedLabel: 'Necessidade do Cabelo',
  hairTypeLabelError: 'Por favor, escolha um tipo de cabelo.',
  dobLabel: 'Data de nascimento',
  emailLabel: 'Seu e-mail',
  emailHint: 'Usaremos seu e-mail APENAS para notificá-lo sobre seu envio.',
  writeReviewTerms: `Ao selecionar este item e clicar no botão Enviar, eu concordo com as condições informadas em`,
  termsAndCondition: 'Termos e condições.',
  writeReviewTrust: '<strong>Termos e Política de Privacidade.</strong> Ao se inscrever, você reconhece que: Você tem no mínimo 18 anos, leu e concorda com os <a href="https://termsandconditions.pg.com/pt-br/" target="_blank" class="text-lightorange">Termos e Condições</a> da P&G e <a href="https://privacypolicy.pg.com/pt-BR/" target="_blank" class="text-lightorange">Política de Privacidade</a>. Para melhor adequar nossas comunicações às suas necessidades, combinaremos os dados pessoais (Nós coletamos e podemos combinar as informações que recebemos quando você entra em contato conosco por telefone, visita nossos sites ou aplicativos, utiliza nossos dispositivos, visualiza nossos anúncios on-line ou quando obtemos informações de outras fontes legítimas e disponíveis).',
  writeReviewTrustComm:'<strong>Suas Escolhas</strong> Você pode exercer seus direitos de proteção de dados pessoais (conforme explicado em nossa Política de Privacidade, você poderá: confirmar a existência do tratamento, acessar seus dados pessoais, corrigir dados incompletos, inexatos ou desatualizados, solicitar a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou em desconformidade, ser informado sobre a possibilidade de negar consentimento e sobre as consequências, solicitar a portabilidade para outro fornecedor de serviço ou produto, revogar seu consentimento, restringir ou opor-se ao tratamento, solicitar informações sobre o uso e compartilhamento dos seus dados pessoais e solicitar a revisão de decisões automatizadas) ou alterar suas preferências e escolhas clicando <a href="https://br.pg.com/entre-em-contato-conosco/" target="_blank" class="text-lightorange">aqui</a>.',
  newest: 'ÚLTIMOS LANÇAMENTOS',
  writeReview: '+ DEIXE A SUA AVALIAÇÃO',
  ratingsReviews: 'O que as pessoas estão dizendo?',
  reviewDescription: '',
  mandatoryField: 'Campos Obrigatórios',
  reviewHelpful: 'Esta avaliação foi útil? ',

  reviewYes: 'Sim',
  reviewNo: 'Não',
  previewHeading: 'Visualizar Sua Avaliação',
  yesRecommend: 'Sim, eu recomendo este produto!',
  notRecommend: 'Não, eu não recomendo este produto!',

  reviewThankYou: 'Obrigado pela sua avaliação!',
  reviewThankContent: 'Avaliação Realizada com Sucesso',
  reviewSorry: 'Desculpa!',
  reviewSorryContent:
    'Desculpe, sua avaliação não foi enviada. Tente novamente mais tarde.',
  reviewContinueButton: 'Continuar',
  reviewEditButton: 'Editar',
  reviewSubmitButton: 'Enviar',
  reset: 'Restabelecer',
  apply: 'Aplicar',
  dobYear: 'Ano de nascimento',
  dobMonth: 'mês de nascimento',
  // create password
  user_newPassword: 'Need help remembering your',
  user_createNewAccount: "Don't have an account yet?",
  user_resetPasswordLabel: 'password?',
  user_newAccountLabel: 'Create one!',
  user_firstnameLabel: 'First Name',
  user_lastnameLabel: 'Last Name',
  user_lmailLabel: 'Email',
  user_passwordLabel: 'Password',
  user_confirmPasswordLabel: 'Confirm Password',
  user_showPasswordLabel: 'Show Password',
  user_birthdayLabel: 'Birthday',
  user_zipcodeLabel: 'Zip Code',
  user_registerButtonLabel: 'Create Your Profile',
  user_monthLabel: 'Mês',
  user_yearLabel: 'ano',
  user_firstnameFormatError: 'First Name is invalid.',
  user_lastnameFormatError: 'Last Name is invalid.',
  user_emailFormatError: 'Insira um endereço de e-mail válido.',
  user_confirmEmailMatchError:
    'Email and Confirm Email values must match. Please try again.',
  user_passwordFormatError:
    'The password must be minimum 8 characters, including at least 1 letter and 1 number.',
  user_passwordTipLabel: 'Password creation tips',
  user_passwordTipText:
    'The password must be minimum 8 characters, including at least 1 letter and 1 number.',
  user_confirmPasswordFormatError:
    'Password and Confirm Password values must match. Please try again.',
  user_zipcodeFormatError:
    'The postal area you entered is not valid. Please try again.',
  user_emailOptsText:
    'Yes! Sign me up to receive emails from trusted P&G brands which will help me: <ul><li>Save money with exclusive coupons</li> <li>Get inspired with useful tips & ideas</li> <li>Learn about free samples, new products, exciting promotions and other information from P&G and carefully-selected business partners</li></ul>',
  user_registrationText:
    "This is what you'll use to sign into the site, recover your password, and personalize your experience",
  user_registrationHeadline: 'Create your Braun account',
  user_validationError:
    'Fields marked with * are mandatory. Please complete all mandatory fields and re-submit.',
  user_registrationSuccess: 'Your Registration Is Complete',
  user_grsServiceError: 'Currently service is not available',
  user_loginLinkText: 'Already have an account?',
  signIn: 'Sign In',
  user_signIn: 'FAZER LOGON NO PERFIL PANTENE',
  user_emailLabel: 'Email',
  nickNameCriteriaError:
    'Your nickname has already been taken by another reviewer. Please choose a different one.',
  ageCriteriaError: `Não é possível aceitar suas mensagens ou informações pessoais porque você não atende a nossos requisitos de elegibilidade. No entanto, você ainda poderá conhecer o restante do site e saber mais sobre nossa empresa. Acesse {pgUrl} para obter informações sobre a P&G e suas marcas.`,
  pgCom: 'www.pg.com',
  serverErrorCount: 'Existe(m) 10 erro(s) na página',
  overallRatingRequiredError: 'Classificação geral obrigatória',
  recommendRequiredError: 'Por favor, escolha uma opção.',
  summaryRequiredError:
    'Insira o resumo da avaliação com no mínimo 10 caracteres.',
  summaryCharactersError:
    'You must write maximum of 50 characters for this field.',
  descriptionRequiredError:
    'Insira a avaliação com no mínimo 50 e no máximo 400 caracteres.',
  descriptionCharactersError:
    'You must enter characters between 50 to 500 for this field.',
  nicknameRequiredError: 'O apelido é obrigatório.',
  nicknameCharactersError: 'Please enter your nickname up to 25 characters',
  nicknameFormatError: 'Nickname must contain only letters and numbers',
  locationRequiredError: 'Location is required',
  locationCharactersError: 'Enter Your Location',
  dobMonthRequiredError: 'Insira o mês do seu nascimento.',
  dobYearRequiredError: 'Insira o ano do seu nascimento.',
  emailRequiredError: 'O endereço de e-mail é obrigatório.',
  emailFormatError: 'Please enter a valid e-mail address.',
  termsRequiredError: 'Termos e Condições obrigatórios',
  user_submitLabel: 'Sign in',
  user_signedInme: 'Keep me signed in',
  readReview: 'Read all reviews',
  loadmore: 'Carregar mais',
  load: 'Carregar mais',
  buyNow: 'COMPRAR',
  buyNowNew: 'COMPRE AGORA',
  buyNowError: 'Nenhum varejista foi encontrado',
  chooseRetailer: ' Escolher varejista:',
  varientSize: 'tamanho da variante',
  visitNearStore:
    'Para comprar este item, visite diretamente seu varejista on-line favorito ou visite a loja mais próxima.',
  user_grsAgeRestriction:
    'We’re sorry, but we can’t accept your messages or personal information because you do not meet our eligibility requirements. But that doesn’t mean you can’t explore the rest of our site and learn more about us! Check out www.pg.com for information about P&G and its brands',
  pdpTitle: 'Pantene BR',
  homeLabel: 'Página Inicial',
  user_loginMetaTitle: 'LOGIN',
  user_loginMetaDescription:
    'Acesse e faça login para conhecer mais do mundo de Pantene e as dicas de beleza, penteados e muito mais.',
  user_registrationMetaTitle: 'Crie seu  perfil',
  user_registrationMetaDescription:
    'Crie seu perfil pessoal para conhecer mais das dicas de beleza, penteado e todos os produtos Pantene.',
  user_registrationOGTitle: 'Crie sua página de perfil',
  user_childRejectionMetaTitle: 'Child rejection page',
  user_childRejectionMetaDescription: 'Child rejection page.',
  user_childRejectionnOGTitle: 'Child rejection page',
  forgotPasswordMetaTitle: 'Redefir sua senha',
  forgotPasswordMetaDescription: 'Redefir sua senha',
  createPasswordMetaTitle: 'Reset Password',
  createPasswordMetaDescription:
    'Esqueceu a sua contrassenha? Acesse e substitua. Siga conhecendo o mundo de Pantene. Acesse agora.',
  createPasswordOGTitle: 'ResetPasswordPage',
  writeReviewtitle: 'Back to product details',
  user_trustPrivacyText:
    '<P>A confiança é um alicerce da nossa missão corporativa e o sucesso do nosso negócio depende dela. A P&G tem o compromisso de manter sua confiança ao proteger as informações pessoais que coletamos sobre você, nosso consumidor.</P>',
  user_profileViewTitleLabel: 'O seu Perfil',
  user_profileViewSubTitleLabel: 'Your basic information',
  user_profileEditTitleLabel: 'Edit your profile',
  user_profileEditLabel: 'Edit',
  user_profileUpdateLabel: 'Save Changes',
  user_profileResetPwdLabel: 'Create your new password',
  user_resetPassword: 'Reset your password',
  user_setPassword: 'Set your password',
  user_resetPasswordSubtitle:
    'Please enter your e-mail address to reset your password.',
  user_resetSubmit: 'Create your New Password',
  user_resetPasswordSuccessTitle: 'THANK YOU!',
  user_resetPasswordSuccessSubtitle:
    'You will receive an e-mail very shortly containing a link to reset your password.',
  user_resetPasswordSuccessLinkText1:
    'Didn’t receive the e-mail? Return to the ',
  user_resetPasswordSuccessLinkText2: ' page to try again.',
  user_resetPasswordText: 'Reset Password',
  user_viewProfileMetaTitle: 'View Profile',
  user_viewProfileMetaDescription: 'View Profile',
  user_editProfileTitle: 'Editar perfil',
  user_editProfileMetaTitle: 'Edit Profile',
  user_editProfileMetaDescription: 'Edit Profile',
  user_editProfileOgDescription: 'EditProfilePage',
  user_requiredPasswordTitle: 'Create a new password',
  user_requiredPasswordSubTitle: 'Please enter the information below',
  user_requiredPasswordMetaTitle: 'Reset password',
  user_requiredPasswordMetaDescription: 'Reset password',
  user_resetPasswordThankYouPageMetaTitle: 'Reset password thank you page',
  user_resetPasswordThankYouPageMetaDescription:
    'Reset password thank you page',
  user_createProfileThankYouPageMetaTitle: 'Create Profile thank you page',
  user_createProfileThankYouPageMetaDescription:
    'Create Profile thank you page',
  user_createProfileErrorMetaTitle: 'Create profile error',
  user_createProfileErrorMetaDescription: 'Create profile error',
  welcomeLabel: 'Welcome',
  logoutLabel: 'Logout',
  header_SigninLabel: 'Sign In',
  header_RegistrationLabel: 'Register',
  header_LogoutDialogTitle: 'Logout Confirmation',
  header_LogoutDialogText: 'Are you sure you want to logout?',
  footer_CountriesLabel: 'Countries / Regions',
  footer_CountryNameLabel: 'Canada / English',

  user_nextLabel: 'Next',
  user_setPasswordTitle: 'Create Your New Password',
  user_loginResetPasswordTitle: 'Your Password Has Been Reset',
  user_loginResetPasswordSubTitle:
    'Get started by signing into your Braun account',
  countrySelectorTitle: 'Selecione seu país/sua região',
  countrySelectorMetaTitle: 'Country selector | Pantene BR',
  countrySelectorMetaDescription: 'Country selector | Pantene BR',
  searchPage_ProductResults: 'RESULTADOS DO PRODUTO',
  searchPage_ContentResults: 'RESULTADOS DO CONTEÚDO',
  searchPage_Alphabetical: 'Alphabetical',
  searchPage_HighestRated: 'MAIS BEM AVALIADOS',
  searchPage_ReverseAlphabetical: 'Reverse Alphabetical',
  searchPage_Relevance: 'Relevance',
  searchBoxAnchorTitle:
    'Search Our Site For Products and Articles | Pantene BR',
  searchBoxPlaceholder: 'How can I help you?',
  searchBoxInputTitle: 'Type search term here',
  searchBoxRecommendedContents: 'Recommended Contents',
  searchBoxRecommendedProducts: 'Recommended Products',
  searchTabHeading: ['RESULTADOS DO PRODUTO', 'RESULTADOS DO CONTEÚDO'],
  contact_metaTitle: 'Dúvidas? Entre em contato conosco | Pantene',
  contact_metaDescription:
    'Got a question about Pantene you need answered? We&#39;re here to help with any questions you may have. Check out our FAQ section or contact us by phone or email.',
  contact_url:
    'https://consumersupport.pg.com/carehub/?brand=Pantene&language=EN&country=GB&GTIN=undefines&username=undefined?brand=Pantene&language=en&country=GB&GTIN=undefined&username=undefined',
  searchPagetitle: 'Search Our Site For Products and Articles | Pantene BR',
  searchPageMetatitle: 'Search Our Site For Products and Articles | Pantene BR',
  searchPageMetaDesc: 'Search Our Site For Products and Articles | Pantene BR',
  searchPageOrgtitle: 'Search Our Site For Products and Articles | Pantene BR',
  searchPageOrgDesc: 'Search Our Site For Products and Articles | Pantene BR',
  searchPageResultsCount1: 'Showing ( ',
  searchPageResultsCount2: ' ) Results',
  searchPageShowingResults: 'Search results for',
  searchresults: 'Search Results',
  searchPageSortBy: 'Organizar por',

  pageNotFoundTitle: 'Server Error - Page Not Found',
  pageNotFoundDesc:
    'The page you’re looking for can’t be found. Check the URL and try again, or visit our home page',
  pageNotFoundMetaTitle: '404 - Page not found | Pantene BR',
  pageNotFoundMetaDescription: '404 - Page not found | Pantene BR',
  adchoices: 'AdChoices',

  // Product Registration

  pr_ageConsentText: `<div class="ageoptins">  Ich bestätige, dass ich über 18 Jahre alt bin. Ich habe die  <a href="https://privacypolicy.pg.com/de/" target="_blank" rel="noopener noreferrer">Datenschutzbestimmung</a> gelesen und akzeptiere sie <span class="mandatorsymbol" style="display: none;"> * </span>  </div>`,
  pr_ageConsentErrorMessage:
    'Um teilzunehmen, müssen Sie die Teilnahmebedingungen und die Datenschutzbestimmung akzeptieren.',
  pr_backToEANInput: 'Zurück zur EAN Eingabe',
  pr_iCannotFindEANCode: 'Ich kann den EAN-Code nicht finden',
  pr_typeNumber: 'Type Number',
  pr_typeNumberError: 'Type Number not found',
  pr_typeNumberHelperText:
    'The type number is a four-digit number that you can find on the back of your Braun device. Enter the number and select your device from the list.',
  emailPopup:
    'email address is registered to our site. we are rediected you to our login page',
  pr_register_formHeading: 'Personal Information',
  pr_email_address: 'E-mail address',
  pr_confirm_email_address: 'Confirm e-mail address',
  pr_first_name: 'First name',
  pr_last_name: 'Surname',
  pr_salutation: 'Salutation',
  pr_select_helptext: 'Please choose',
  pr_address_text: 'Address',
  pr_yourProduct: 'Your Product',
  pr_stateCode: 'DE',
  pr_consumerIdNotGenerated:
    'Your Consumer ID has not been generated yet. Please try registering after some time',
  pr_address_street: 'Street',
  pr_address_houseno: 'House no. ',
  pr_address_zipcode: 'Postcode ',
  pr_address_place: 'Place',
  pr_country_label: 'Country',
  pr_automatic_search: 'Automatic address search',
  pr_dob: 'Data de nascimento',
  pr_select_date: 'TT',
  pr_select_month: 'MM',
  pr_select_year: 'YYYY',
  pr_enableAutoAddress: 'Automatic Address Search',
  pr_enableManual_helptext:
    'Please enter the address and select the correct address from the dropdown list',
  pr_enableManualAddress: 'Manual address entry',
  pr_ean: 'EAN',
  pr_purchaseDate: 'date of purchase',
  pr_purchaseReason: 'Who is the Braun product for?',
  pr_submit: 'Submit',
  pr_verification_heading: 'Product Verification',
  pr_verification_subheading:
    'The 13-digit EAN code can be found on the product packaging below the bar code',
  pr_recaptchaError: 'Please validate the recaptcha field',
  pr_purchaseDateLimitError:
    'The date of purchase must not be more than 2 years in the past',
  pr_purchaseReasonText: 'Who is the Braun product for?',
  pr_optIn_text: 'Opt Ins',
  pr_registered_productText: 'Your Registered Product:',
  pr_registered_DescriptionDate:
    'Your product warranty has been extended by 1 year and will run until ',
  pr_registered_DescriptionText:
    'Within this warranty period, we will, at our discretion, repair or replace the device free of charge in the event of defects in materials or workmanship.',
  pr_registered_DescriptionLinkText: 'More information at ',
  pr_registered_ThankYouText: 'Thank you for your trust in Braun',
  pr_emailText1: 'It worked!',
  pr_emailText2:
    'In the near future you will receive an e-mail confirming your address.',
  pr_emailText3:
    "If you sign up to receive emails with coupons, sweepstakes, and great P & G tips, you'll need to confirm this with one click in the email.",
  pr_ageLimitMessage:
    'Unfortunately, we can not accept your messages or personal information because you do not meet our eligibility requirements. But you can visit the rest of our website and learn more about us! For more information about P & G and its brands, visit ',
  pr_ageContentLink: 'www.pg.com',
  pr_ageContentLinkUrl: 'https://www.pg.com',
  pr_successMessageLink: 'www.service.braun.com',
  pr_successMessageLinkUrl: 'https://www.service.braun.com',
  user_typeNumberFormatError: 'Invalid error',
  pr_addressPlaceHolder: 'Please enter valid address',
  // Money Back
  mbg_register_formHeading: 'Personal Information',
  mbg_email_address: 'E-mail address',
  mbg_urlHere: 'hier herunterladen',
  mbg_confirm_email_address: 'Confirm e-mail address',
  mbg_emailText:
    'The application for participation is only possible with a valid e-mail address.',
  mbg_first_name: 'First name',
  mbg_last_name: 'Surname',
  mbg_salutation: 'Salutation',
  mbg_select_helptext: 'Please choose',
  mbg_address_text: 'Address',
  mbg_address_street: 'Street',
  mbg_address_houseno: 'House no. ',
  mbg_address_zipcode: 'Postcode ',
  mbg_address_place: 'Place',
  mbg_country_label: 'Country',
  mbg_automatic_search: 'Automatic address search',
  mbg_dob: 'Data de nascimento',
  mbg_select_date: 'TT',
  mbg_select_month: 'MM',
  mbg_select_year: 'YYYY',
  mbg_enableAutoAddress: 'Automatic Address Search',
  mbg_enableManual_helptext:
    'Please enter the address and select the correct address from the dropdown list',
  mbg_enableManualAddress: 'Manual address entry',
  mbg_ean: 'EAN',
  mbg_purchaseDate: 'date of purchase',
  product_eanNotFound: 'EAN not found',
  mbg_submit: 'Submit',
  mbg_verification_heading: 'Product Verification',
  mbg_verification_subheading:
    'The 13-digit EAN code can be found on the product packaging below the bar code',
  mbg_recaptchaError: 'Please validate the recaptcha field',
  mbg_purchaseDateLimitError:
    'The date of purchase must not be more than 1 years in the past',
  mbg_purchaseReasonText: 'Who is the Braun product for?',
  mbg_optIn_text: 'Opt Ins',
  mbg_automatically: '(automatisch)',
  user_eanFormatError: 'Invalid error',
  mbg_addressPlaceHolder: 'Please enter valid address',
  mbg_eanText: '13-digit number on the packaging',
  mbg_priceLabel: 'Price',
  user_priceFormatError: 'enter valid price',
  mbg_consignee: 'Consignee',
  mgb_iban: 'IBAN',
  mbg_accountInstitute: 'Credit Institute',

  // Store locator messages
  userLocationName: 'Your Location',
  initialLocationName: 'Default location',
  unableToFetchUser: 'unable to fetch user user location!',
  placeholder: 'Search places...',
  getDirectionInList: 'Get Direction',
  unableToFindAddress: 'Unable to find address!',
  unableToContactServer: 'Unable to contact server!',
  searchIconAltText: 'Search store..',
  // End of store locator messages
  selectedCountry: 'Canada/English',
  countrySelectorDialogTitle: 'Selecione seu país/sua região',
  countrySelectorDialogCloseBtnAriaLabel: 'Fechar seletor de país.',
  //Article Listing Constants
  alp_article_plural: 'Artigos',
  alp_article_singular: 'Artigo',
  alp_sort: 'Organizar por',
  // Product Listing Constants
  all_products: 'TODOS OS PRODUTOS',
  plp_product_plural: 'Produtos',
  contenidos: 'Contenidos',
  plp_product_singular: 'Produto',
  plp_constant_showing: 'Showing: ',
  plp_constant_sort: 'Organizar por',
  plp_constant_loadMore: 'Carregar mais',
  plp_constant_browseByCategory: 'Browse by Category',
  plp_constant_filterAndBrowse: 'Filter & Browse',
  plp_constant_viewing: 'Viewing:',
  plp_constant_clearAll: 'Clear All',
  plp_constant_recentlyViewedProducts: 'Recently Viewed Products',
  plp_constant_compareProduct: 'Compare Product',
  plp_constant_compareNow: 'Compare Now',
  plp_constant_loading: 'Loading...',

  storeLocator_getDirections: 'Get Directions',
  storeLocator_noOfStoresAvailable: 'No of stores available',
  storeLocator_showingStoresinXkmRadius: 'Showing stores in #number km radius',
  janrain_errorMsg1:
    'We’re sorry, but we can’t accept your messages or personal information because you do not meet our eligibility requirements. But that doesn’t mean you can’t explore the rest of our site and learn more about us! Check out',
  janrain_errorMsg2: 'for information about P&G and its brands.',
  janrain_pgom: 'www.pg.com',

  // Warranty Extension
  registerYourProduct: 'Register your product',
  warrantyInfo:
    'Please provide information on your Braun product in the fields below. Please note that the warranty extension can only be applied for products purchased no more than 2 years ago. As well, the warranty extension is only valid for Braun male and female grooming products, replacement parts and refills excluded.',
  productInfo:
    'The product type number is a 4-digit code you will find directly on your Braun product. Usually, it is declared as "Type: XXXX". If you can not find it directly, maybe it is hidden behind the slide-out trimmer of your device.',
  productTypeLabel: 'Product type number (4 digits)',
  chooseModelLabel: 'Your product',
  purchaseDateLabel: 'Date of purchase',
  extendedWarrantyPeriodLabel: 'Extended warranty period',
  loginButtonText: 'ENTRAR',
  regiserButtonText: 'Register',
  modelsNotFoundError:
    'We are sorry! Something seems to be wrong with the product type number entered. Please make sure that the type number belongs to a Braun product that is still within the manufacturer’s warranty period and it has 4 digits.',
  warrantyPeriodError:
    'Please note that the warranty extension can only be applied for products that are still within the manufacturer’s warranty period',
  extendWarrantyCertificateTitle: 'Download your extended warranty certificate',
  registrationThanksMessage:
    'Thanks a lot for registering your Braun product and creating your personal Braun account.',
  loginThanksMessage: 'Download your extended warranty certificate',
  redeemMessage:
    'To redeem your extended warranty on your Braun product please keep the certificate along with your proof of purchase.',
  printCertificateMessage:
    'Download and print your warrranty extension certificate.',
  downloadButtonText: 'Download',
  loginMessage: 'Log in using your Braun account!',

  //pdp page
  about: 'About',
  overview: 'Descrição',
  instagram: 'From Our Instagram Stories',
  ingredients: 'Ingredientes',
  ingredientsTitle: 'Ingredientes',
  ingredientsMessage: 'ingredientsMessage',
  viewAllIngredients: 'VISUALIZAR TODOS OS INGREDIENTES',
  // Page slugs
  contactUsSlug: 'contact-us',
  registrationSlug: 'createprofile',
  registrationErrorSlug: 'createprofile/createprofileerror',
  loginSlug: 'loginpage',
  loginSuccessSlug: 'loginpage/create-profile-thank-you-page',
  resetPasswordSlug: 'forgot-password',
  //Quizpage messages
  getStarted: 'Comece Agora',
  'start-over': 'Start Over',
  'related-articles': 'Artigos relacionados',
  title: 'Thank You',
  message: 'Thanks for your feedback !',
  // SEOProduct Constants
  contextSEOProduct: 'http://schema.org',
  typeSEOProduct: 'Review',
  typeRatingSEOProduct: 'Rating',
  bestRatingSEOProduct: '5',
  ratingValueSEOProduct: '0',
  SEOProductName: 'Pantene',
  worstRatingSEOProduct: '1',
  typeReviewSEOProduct: 'Review',
  AggregateRatingSEOProduct: 'AggregateRating',
  //404 Error Page
  errorPage: '404',
  notFoundPage: 'Opa, esta página não foi encontrada!',
  previousPage: 'VOLTAR À PÁGINA ANTERIOR',
  //GAPageViews
  zeroPageViews: '0',
  // Layout
  inputField: 'Em que posso ajudar?',
  cookieConsent: 'Consentimento de cookie',
  login: 'ENTRAR',
  register: 'CADASTRAR',
  Gosteibotão:'Gostei botão',
  //Write Review
  starRatinglabel: 'Avaliação',
  yourReviewLabel: 'Sua análise',
  //Registration Page
  registrationPageTitle: 'Vantagens em se cadastrar no site:',
  createProfile: 'CRIE SEU PERFIL PANTENE',
  LoginListItem1: 'Amostras grátis, ofertas e promoções.',
  LoginListItem2:
    'Conheça em primeira mão os lançamentos e notícias sobre a Pantene.',
  LoginListItem3: 'As últimas dicas e tendências de penteados',
  LoginListItem4: 'E muito mais!!',
  gender: 'Gênero',
  dateofbirth: 'Data de nascimento',
  registerButton: 'Criar conta',
  passwordCreationTips: 'Dicas para a criação da senha',
  passwordCreationTipsText:
    'The password must be at least 8 characters long, and must include at least 1 letter and 1 number.',
  mainHairFrustrationLabel: 'Qual é a sua maior frustração com seus cabelos?',
  oilynessLevel: 'Qual é o nível de oleosidade dos seus cabelos?',
  passwordInfo:
    'A senha deve ter no mínimo 8 caracteres e deve incluir, pelo menos, 1 letra em maiúscula e 1 número.',
  hairfrustrationInfo:
    'Por que perguntamos quais são seus desafios e frustrações atuais?',
  infoButtonText: 'Mostrar Resposta',
  hairMainFrustrationDetails:
    'Embora possamos fazer suposições científicas com base no seu tipo de cabelo, queremos ter certeza de que estamos ouvindo você. Todo o cabelo é único e requer atendimento personalizado.',
  hairtypeLabel: 'Qual é o tipo do seu cabelo?',
  hairtypeDetails:
    'O seu tipo de cabelo natural evidencia problemas normais como fraqueza, friss, oleosidade, secura, etc.',
  hairtypeInfo: 'Por que perguntamos sobre seu tipo de cabelo?',
  hairOilynessInfo:
    'Por que perguntamos se o seu cabelo engordura rápido ou fica limpo entre as lavagens?',
  hairOilynessnDetails:
    'Os produtos variam o nível de concentração dos ingredientes que limpam o óleo de cabelo e queremos saber qual é o seu caso para lhe recomendar o melhor!',
  //Login page

  logInheading: 'Deseja ter um Cabelo Pantene?',
  forgotPasswordText: 'Esqueceu a senha?',

  //Password reset

  paswordReset: 'REDEFIR SUA SENHA',
  enterEmailAddressToResetPassword:
    'Por favor indique o seu endereço de e-mail para efectuar o reset da sua password',
  next: 'Próximo',
  thankyou: 'OBRIGADO!',
  receiveEmailText:
    'Brevemente irá receber um correio electrónico com um link para efectuar o reset da sua password.',
  emailNotReceived: 'Não recebeu o e-mail?Regresse á ',
  tryagain: 'para tentar novamente.',
  forgotPasswordLinkText: 'reset de password',
  createYourNewPassword: 'Criar Nova Senha',
  success: 'SUCESSO!',
  changePasswordSuccessMessage:
    'Sua senha foi redefinida com sucesso. Faça logon novamente com sua nova senha para acessar sua conta.',
  passwordSaved: 'Sua senha foi redefinida com sucesso.',

  //EditProfile

  yourProfile: 'O SEU PERFIL',
  savechanges: 'SALVAR',
  changepassword: 'Mudar senha',
  savepassowrd: 'SALVAR SENHA',
  myprofile: 'MEU PERFIL',
  logout: 'Log out',

  //ChildRejection
  ChildRejectionErrorMessage:
    'Não é possível aceitar suas mensagens ou informações pessoais porque você não atende a nossos requisitos de elegibilidade. No entanto, você ainda poderá conhecer o restante do site e saber mais sobre nossa empresa. Acesse www.pg.com para obter informações sobre a P&G e suas marcas.',
  //AccordianTab
  sectionContainer: 'SectionContainer',
  resize: 'resize',
  //Article-listing
  scroll: 'scroll',
  breadcrumbContainer: 'breadcrumbContainer',
  productlist: 'product-list',
  pagenumber: 'pagenumber',
  itemurl: 'itemurl',
  scroll_adjust_div: 'scroll_adjust_div',
  scrolling_div: 'scrolling_div',
  div_anchors: 'div_anchors',
  product_count: 'product_count',
  facet: 'facet',
  img: 'img',
  //dropdown
  click: 'click',
  //ProductCard
  ListingCard: 'ListingCard',
  //Bannerbackground
  backgrounddefault: 'background-default',
  //devices
  desktop: 'desktop',
  desk: 'desk',
  mobile: 'mobile',
  tablet: 'tablet',
  //Banner
  bannertextleft: 'banner-text-left',
  VideoButton: 'VideoButton',
  LinkButton: 'LinkButton',
  ImageButton: 'ImageButton',
  HairBiology: 'HairBiology',
  Callout: 'Callout',
  //HomeBanner
  eventload: 'load',
  homebanner: 'homebanner',
  textWrapper: 'textWrapper',
  textScroll: 'textScroll',
  homepagetextleft: 'home-page-text-left',
  dataaos: 'data-aos',
  faderight: 'fade-right',
  zoomin: 'zoom-in',
  fadeleft: 'fade-left',
  imageStylesleft: 'imageStylesleft',
  //Card
  stackedCard: 'stackedCard',
  ImageSet: 'ImageSet',
  ProductCard: 'ProductCard',
  //stillConfusedDesktop
  stillConfusedDesktop: 'stillConfusedDesktop',
  //Carousel
  Banner: 'Banner',
  Carousel: 'Carousel',
  Image: 'Image',
  VideoCard: 'VideoCard',
  //Contentcard
  contentpagetextright: 'content-page-text-right',
  contentPage: 'contentPage',
  // Footer
  HeadingTypes: 'HeadingTypes',
  //SocalShareApps
  shareinstragram: 'Instagram',
  whatsApp: 'WhatsApp',
  facebook: 'Facebook',
  twitter: 'Twitter',
  pinterest: 'Pinterest',
  hairadvisor: 'hair-advisor',
  body: 'body',
  socialDivCloseStyle: 'socialDivCloseStyle',
  hidden: 'hidden',
  socialconnectdiv: 'social-connect-div',
  socialPopUpOPen: 'socialPopUpOPen',
  socialPopUpClose: 'socialPopUpClose',
  socialShareDivClose: 'socialShareDivClose',
  imageurl: 'imageurl',
  noopenernoreferrer: 'noopener noreferrer',
  blank: '_blank',

  //Header
  freezebody: 'freeze-body',
  menuopenbar: 'menuopenbar',
  menuopened: 'menuopened',
  overflowhidden: 'overflow-hidden',
  hiddenslidingleft: 'hidden sliding-left',
  blockslidingright: 'block sliding-right',

  //HeadingBanner
  middleHeader: 'middleHeader',
  shareProduct: 'shareProduct',
  productSticky: 'productSticky',
  share: 'share',
  buyNowBtnWrapper: 'buyNowBtnWrapper',
  buyNowBtn: 'buyNowBtn',
  topImageWrapper: 'topImageWrapper',
  mask: 'mask',
  topImage: 'topImage',
  topHeaderText: 'topHeaderText',
  topHeaderTextMain: 'topHeaderTextMain',
  topHeaderTextBig: 'topHeaderTextBig',
  topHeaderTextSmall: 'topHeaderTextSmall',
  product: 'product',

  //HomepageCarousel
  picture: 'picture',
  nossosfav: 'Nossos Favoritos',

  //Layout
  content: 'content',
  pageheader: 'page-header',
  footer: 'footer',
  blur8: 'blur-8',
  visible: 'visible',
  searchCloseDiv: 'searchCloseDiv',

  //Menu
  eventmenuclick: 'event_menu_click',
  animate: 'animate',
  //MenuItem
  leftArrowLastLevel: 'leftArrowLastLevel',
  hairAdvisorMenuText: 'hairAdvisorMenuText',
  //MenuListDT
  one: '1',
  two: '2',
  three: '3',
  //Navigation
  desktopNavClose: 'desktopNavClose',
  icon: 'icon',
  closeMenubar: 'closeMenubar',
  iconMenuId: 'iconMenuId',
  name: 't',
  radio: 'radio',
  //ListingCard
  nounderline: 'no-underline',
  //Articlecarousel
  articleproducts: 'article_products',
  collection_data: 'collection_data',
  //FacetPanel
  checkboxinactive: 'checkbox-inactive',
  checkboxactive: 'checkbox-active',
  //Productlistingpage
  prodtype: 'prod-type',
  prodname: 'prod-name',

  //Quiz
  single_image: 'single_image',
  nochallenges: 'no-challenges',
  getAdviceBtn: 'getAdviceBtn',
  noneoftheabove: 'none-of-the-above',
  multi_text: 'multi_text',
  single_text: 'single_text',
  sliderrangedual: '.slider-range-dual',
  sliderrangedotted: '.slider-range-dotted',
  sliderrange: '.slider-range',
  max: 'max',
  touchend: 'touchend',
  range_style: 'range_style',
  range: 'range',
  range_freq: 'range_freq',
  testScroll: 'testScroll',
  testScroll2: 'testScroll2',
  multi_text_priority: 'multi_text_priority',
  range_level: 'range_level',
  start_over: "Ricomincia dall'inizio",
  related_articles: 'Related Articles',
  pagenotfound: 'page-not-found',
  goback: '/it-it/consulenza-capelli',

  //WecanHelp
  hairadvisorwecanhelp: 'hair-advisor-we-can-help',
  wecanhelpStyle: 'wecanhelpStyle',
  //ALPRelatedarticles
  articlePage: 'articlePage',
  //RelatedArticles
  contentdefault: 'content-default',
  //Breadcrumb
  block: 'block',
  hiddenmdinlineblock: 'hidden md:inline-block',
  fontbold: 'font-bold',
  //socialshare
  article: 'article',
  socialShareModal: 'socialShareModal',
  scrollSticky: 'scrollSticky',
  socialShareModalStyle: 'socialShareModalStyle',
  //storycard
  pantenestorycard: 'pantene-story-card',
  //userinstruction
  none: 'none',
  leftwrapper: 'left-wrapper',
  rightwrapper: 'right-wrapper',
  slideText: 'slideText',
  slideSection: 'slideSection',
  slideImage: 'slideImage',
  ContentTypeRichText: 'ContentTypeRichText',

  //others
  middleSection: "middleSection",

  //videoBanner
  VideoBanner: 'VideoBanner',
  //videocard
  iframe: 'iframe',
  //videocarousel
  VideoCarousel: 'VideoCarousel',
  //thumbsup
  thumbsUp: 'thumbsUp',
  thumbsDown: 'thumbsDown',
  wasthishelpful: 'Esse artigo foi útil?',

  //ReviewError
  javascriptvoid: 'javascript:void(0);',
  //Write review
  reviewrecommend: 'recommend',
  reviewnotRecommend: 'notRecommend',
  True: 'True',
  False: 'False',
  overallRating: 'overallRating',
  termsAndConditions: 'termsAndConditions',
  Maggioriinformazionisuicookie: 'Maggiori informazioni sui cookie.',

  //writereviewrating
  starRating: 'starRating',
  simple: 'simple',
  raised: 'raised',
  rounded: 'rounded',
  primaryRadio: 'primaryRadio',
  hyphenRating: 'hyphenRating',
  secondaryRadio: 'secondaryRadio',

  //buynowlite
  buy_now_logo: 'buy_now_logo',
  andtimes: '&times;',

  //Modal
  opacity85: 'opacity-85',
  keydown: 'keydown',
  Escape: 'Escape',
  escapeKeyDown: 'escapeKeyDown',
  backdropClick: 'backdropClick',

  //ListItemIcon
  image: 'image',
  span: 'span',
  //Portal
  reactportal: 'react-portal',

  //ReadReview
  sortRatingdesc: '&sort=Rating:desc',

  //checkbox
  checkbox: 'checkbox',
  //spinner
  Loading: 'Loading...',
  //VideoButton
  Image_Button: 'Image-Button',
  IconButton: 'Icon-Button',
  SimpleButton: 'Simple-Button',

  //articledetailpage
  articledetailspage: 'article-details-page',
  Ingredient: 'Ingredient',
  bannerScroll: 'bannerScroll',
  viewsarticle: 'views-article',
  mobilestyle: 'mobile-style',
  heroTitleId: 'heroTitleId',
  wasthishelpfulid: 'was-this-helpful',
  resizetext24: 'resize-text-24',
  addclass: 'addclass',
  transitionpt: 'transition-pt',
  Mobilebannersticky: 'Mobilebannersticky',
  mobilesticky: 'mobile-sticky',
  mobilearticleoverlay: 'mobile-article-overlay',
  wasthis: 'wasthis',
  accordianClose: 'accordianClose',
  accordianOpen: 'accordianOpen',
  wasThisHelpfulSession: 'wasThisHelpfulSession',
  Pantene: 'Pantene',
  SUCCESS: 'SUCCESS',
  whiteshadow: 'white-shadow',
  summarylargeimage: 'summary_large_image',
  Share: 'Share',

  //artcile-list
  sortarticle: 'sort',
  page: 'page',
  az: 'a-z',
  articlelistingpage: 'articlelistingpage',

  //product-listing
  newestproduct: 'newest',
  productlistingpage: 'productlistingpage',

  //homepage
  homepage: 'homepage',
  ratingsearch: 'rating',
  desc: 'desc',
  //searchpage
  productName: 'productName',
  ratingplus: 'rating+',
  mostviewed: 'most-viewed',
  za: 'z-a',
  SearchCardHorizontal: 'SearchCardHorizontal',
  articleListHolder: 'articleListHolder',
  SearchCard: 'SearchCard',

  //story
  storypage: 'story-page',
  bannerStoryScroll: 'bannerStoryScroll',
  powerOfHairStyle: 'powerOfHairStyle',
  howToStartedAll: 'howToStartedAll',
  MobilebannerstickyStory: 'MobilebannerstickyStory',
  mobilestylestory: 'mobile-style-story',
  powerHairBanner: 'powerHairBanner',

  //banner

  minWidthBanner: '(min-width: 768px)',
  minWidthTwoBanner: '(min-width: 1024px)',
  productPageURL:'/pt-br/produtos/',
  bannerReleatedCard:'bannerReleatedCard',



  // Registraion
  termsMaintext:'Seus dados, data de nascimento e CEP serão coletados para te conhecermos, entendermos seus hábitos e quais produtos e iniciativas atendem suas necessidades.',
  homePageURL:'https://pantene.com.br/pt-br',
  termsConditionText:'Você se cadastrará como usuário do ',
  targetBlank: '_blank',
  termsAnchortext:'https://pantene.com.br',
  termsText1:' do qual a ',
  privacyUrl:'https://privacypolicy.pg.com/pt-BR/',
  ProctorGamble:'Procter & Gamble',
  optStatus:' é a controladora de dados. Ao se inscrever, você reconhece que:',
  emailOptIn:'<div id="opt1"><span class="font-extrabold">Opt In de e-mail Marketing.</span> Eu quero receber e-mails, ofertas e cupons de Pantene e outras  <a class="font-HelveticaNeueBold text-termGold text-14 md:text-14 pt-0 leading-16 -ml-25 termAnchorTag" target="_blank" href="https://br.pg.com/marcas-e-produtos-pg/">marcas</a> P&G confiáveis.</div>',
  SkiptoMain:'Pular para o conteúdo',
  footerPrivacy: 'Privacidade',
  PDPAccordionTitle: 'DETALLES Y CARACTERÍSTICAS DEL PRODUCTO',
  bannerPicture: 'bannerPicture',
  bannerLinkeImg: 'https://images.ctfassets.net/4ck2s8k0bkzh/CcrcmzBbqqqoSZZOGY9LB/4d87e4dee08772cde81da6b287d46d64/TO_BANNER_04_LINEA.webp',
    contentBorderImage: {
        desktop: 'https://images.ctfassets.net/4ck2s8k0bkzh/aIzdsAiQtUWAve8itAyP5/8705806bb649e0d4e794187001df452f/TO_BANNER_06_LINEA.webp',
        mobile: 'https://images.ctfassets.net/4ck2s8k0bkzh/7MqyjY71vI5mBwsRhemeat/093c3bab968057da7014545c005e692c/TO_BANNER_06_LINEA_SP.webp'
    },
    successImgIcon: 'https://images.ctfassets.net/27loxu94eo0x/2bEcSm1E9xOlHkAtzC0rDW/fe2a96e72227d2b25484be390390d7cc/TO_BANNER_06_ICONO.png',
    emptyStar: 'https://images.ctfassets.net/bpsnf1n7mj27/4vgFthW5gFr3eKxJoKzVsB/1e0afdda3a30a7debe13f246cb39322a/ReviewStarsEmpty.svg',
    filledStar: 'https://images.ctfassets.net/bpsnf1n7mj27/14rEisYmw5a9yqnT4wsKWs/275b6dd3475042121c3d05c1c3c7843f/ReviewStars.svg',
    RELATED_PRODUCT_TITLE: 'Productos que te pueden gustar',
    ratingsReviewsID:'ratingsReviews',
    ratingsReviews: "¿Qué opina la gente?",
};